import React from 'react';

import {Helmet} from 'views/module';

import JobList from 'views/scenes/career/job_list/JobList';

const CareerDashboard = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <JobList
      />
    </>
  );
};

export default CareerDashboard;
